// extracted by mini-css-extract-plugin
export var container = "_f0-0";
export var content = "_f0-3";
export var customerTitle = "_f0-4";
export var empty = "_f0-5";
export var gray = "_f0-6";
export var header = "_f0-7";
export var info = "_f0-8";
export var loading = "_f0-2";
export var loadingCard = "_f0-9";
export var oneLine = "_f0-a";
export var personName = "_f0-e";
export var pillContainer = "_f0-b";
export var selected = "_f0-1";
export var text = "_f0-c";
export var twoLines = "_f0-d";
export var unread = "_f0-f";
export var unreadIndicator = "_f0-g";